// Copyright (c) Bentley Systems
export class Column {
  public name: string | undefined;
  public caption: string | undefined;
  public dataType: string | undefined;
  public isActionInThreeDotMenu: boolean | undefined;
  public isItemActionVisibilityCondition: boolean | undefined;
  public controlOrder: number | undefined;
  public fieldId: number | undefined;
  public isHidden: boolean = false;
  public width?: number | undefined;
  public isTileName: boolean = false;
  public disableToggleVisibility: boolean = false;

  constructor(
    initializer?: any,
    controlOrder?: number,
    fieldId?: number | undefined,
    caption?: string | undefined,
    width?: number | undefined,
    isColor?: boolean | undefined,
    isTileName?: boolean | undefined,
    isImgBase64?: boolean | undefined,
    isAttachment?: boolean | undefined,
    disableToggleVisibility?: boolean | undefined,
  ) {
    if (!initializer) {
      return;
    }
    if (initializer.name) {
      this.name = this.caption = initializer.name;
    }
    if (initializer.dataType) {
      this.dataType = initializer.dataType;
    }
    if (isColor === true) {
      this.dataType = "Color";
    }
    if (caption !== undefined) {
      this.caption = caption;
    }
    this.controlOrder = controlOrder;
    if (fieldId) {
      this.fieldId = fieldId;
    }
    if (width) {
      this.width = width;
    }
    if (isTileName) {
      this.isTileName = isTileName;
    }
    if (isImgBase64 === true) {
      this.dataType = "ImgBase64";
    }
    if (isAttachment === true) {
      this.dataType = "Attachment";
    }
    if (disableToggleVisibility) {
      this.disableToggleVisibility = disableToggleVisibility;
    }
  }
}
